<script setup lang="ts">
defineOptions({
  name: 'DefaultLayout'
})

const route = useRoute()

const titleMap: Record<string, string> = {
  index: 'Home',
  team: 'Team',
  leistungen: 'Leistungen',
  referenzen: 'Referenzen',
  impressum: 'Impressum',
  datenschutz: 'Datenschutz'
}

const pageTitle = computed(() => titleMap[route.name?.toString() ?? ''] ?? '')
</script>

<template>
  <v-app>
    <a href="#main-content" class="sr-only skip-link">Zum Inhalt springen</a>
    <div class="lp-wraper">
      <Header />
      <HeaderImage
        :text="pageTitle"
        image-url="/images/muengstener_bruecke.jpg"
        alt="Müngstener Brücke"
      />
      <main id="main-content">
        <slot></slot>
      </main>
      <Footer />
    </div>
  </v-app>
</template>

<style scoped lang="scss">
.skip-link:focus {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 9999;
  width: auto;
  height: auto;
  padding: 0.75rem 1.5rem;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
  background: #fff;
  color: rgba(var(--v-theme-primary), 1);
  font-weight: 600;
  text-decoration: none;
  border: 2px solid rgba(var(--v-theme-primary), 1);
}
</style>
